import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ps-page-container',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './page-container.component.html',
  styleUrl: './page-container.component.scss',
})
export class PageContainerComponent {}
